import { ThemeMode, ThemeName, themes } from '@shared/shared-components';
import restApi from '~api/backend';
import { isSoikieTheme } from '~platform/platform';
import PLATFORMS from '~platform/platforms';
let PLATFORM_THEMES;
let PLATFORM_THEME_DATA;
export async function loadPlatformTheme() {
    const platformTheme = await restApi().fetchTheme();
    PLATFORM_THEME_DATA = platformTheme;
    PLATFORM_THEMES = {
        [ThemeMode.dark]: {
            ...themes[platformTheme.theme_names[ThemeMode.dark]],
            palette: {
                ...themes[platformTheme.theme_names[ThemeMode.dark]].palette,
                ...platformTheme.palettes[ThemeMode.dark],
            },
        },
        [ThemeMode.light]: {
            ...themes[platformTheme.theme_names[ThemeMode.light]],
            palette: {
                ...themes[platformTheme.theme_names[ThemeMode.light]].palette,
                ...platformTheme.palettes[ThemeMode.light],
            },
        },
    };
    return PLATFORM_THEMES;
}
export function getPlatformThemeData() {
    if (!PLATFORM_THEME_DATA) {
        throw new Error('Platform themes are not loaded yet');
    }
    // special case for Soikie: return frankensteined local-remote info
    if (isSoikieTheme()) {
        const basePlatform = PLATFORMS.soikie;
        return {
            ...PLATFORM_THEME_DATA,
            name: basePlatform.name,
            title: basePlatform.motto,
            logo_with_name: basePlatform.logo,
        };
    }
    return PLATFORM_THEME_DATA;
}
export function getPlatformThemes() {
    if (!PLATFORM_THEMES) {
        throw new Error('Platform themes are not loaded yet');
    }
    return PLATFORM_THEMES;
}
export function getPlatformTheme(themeName) {
    if (themeName === ThemeName.soikieLight) {
        return themes[themeName];
    }
    return getPlatformThemes()[themes[themeName].mode];
}
